firebird
    .directive('messageBanner', [
        'templateCache',
        'helperService',
        function (templateCache, helperService) {
            return {
                restrict: 'E',
                template: templateCache.getTemplate(helperService.getRedesignPathPrefix() + 'message-banner.html'),
                link: function (scope, element) {}
            };
        }
    ])
    .directive('bannerContent', [
        '$rootScope',
        '$window',
        '$timeout',
        function ($rootScope, $window, $timeout) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    var bannerHeight = 0;

                    //Watch for changes in the banner message
                    attrs.$observe('bannerContent', function (newValue) {
                        //If there is a change in message, broadcast the banner height
                        //so that the Header/Body divs can reposition themselves
                        //
                        //The timeout is so that this occurs at the end of a digest cycle...
                        //Otherwise, the outerHeight won't be accurate
                        //
                        // outerHeight is not accurate when browser is zoomed. Use visible check too.
                        $timeout(function () {
                            var currentHeight = element.parent().is(':visible') ? element.parent().outerHeight() : 0;
                            if (bannerHeight !== currentHeight) {
                                bannerHeight = currentHeight;
                                $rootScope.$broadcast('banner-height-changed', bannerHeight);
                            }
                        });
                    });

                    //Watch for changes on window resize
                    angular.element($window).bind('resize', function () {
                        //If there is a change in banner height, broadcast to position Header/Body
                        var currentHeight = element.parent().is(':visible') ? element.parent().outerHeight() : 0;
                        if (bannerHeight !== currentHeight) {
                            bannerHeight = currentHeight;
                            $rootScope.$broadcast('banner-height-changed', bannerHeight);
                        }
                    });
                }
            };
        }
    ]);
